module.exports = __webpack_public_path__ + "static/img/game-logo-jili.faf983b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-jili.png
// module id = Y3vf
// module chunks = 0 1 2 3 4 5 6